import { LoadingPresentationalTable } from 'components/core-v2'

const ROW_OPTIONS = [
  { align: 'left', width: '80%' },
  { align: 'right', width: '20%' }
]

export const Loading = () => <LoadingPresentationalTable rowCount={5} rowOptions={ROW_OPTIONS} />
